module.exports = {
      id: "bread-crum-separator-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#bread-crum-separator",
      toString: function () {
        return this.url;
      }
    }